import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { InputComponent } from '@app/modules/change-requests/interfaces/input-component.class';
import { AuthService } from '@app/services';
import { Job } from '@models/company/job.model';

@Component({
    selector: 'position-input-component',
    template: `
        <div *ngIf="!isLoading">
            <mat-form-field class="no-labels no-helpers">
                <mat-select
                    name="position"
                    placeholder="Select Position"
                    #department="ngModel"
                    [disabled]="disabled"
                    [aria-label]="ariaLabel"
                    [(ngModel)]="value"
                    (selectionChange)="valueUpdated.emit(value)"
                    [errorStateMatcher]="errorStateMatcher"
                >
                    <mat-option></mat-option>
                    <mat-option *ngFor="let job of jobs" [value]="job.id">
                        {{ job.title }}
                    </mat-option>
                </mat-select>
                <mat-error>
                    {{ errorMessage }}
                </mat-error>
            </mat-form-field>
        </div>
    `,
})
export class PositionInputComponent extends InputComponent implements OnInit {
    @Output() valueUpdated: EventEmitter<string> = new EventEmitter<string>();
    isLoading = false;
    jobs: Job[] = [];
    value = '';

    constructor(private auth: AuthService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.jobs = (await Job.param('company', this.auth.company.id).orderBy('title', 'ASC').all())[0];
    }
}
